"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeEncryptedKey = void 0;
const service_client_1 = require("../service-client");
const utils_1 = require("../utils");
/** Stores an encrypted private key and its metadata to the wrapped keys backend service
 *
 * @param { StoreEncryptedKeyParams } params Parameters required to fetch the encrypted private key metadata
 * @returns { Promise<StoreEncryptedKeyResult> } The encrypted private key and its associated metadata
 */
async function storeEncryptedKey(params) {
    const { pkpSessionSigs, litNodeClient } = params;
    const sessionSig = (0, utils_1.getFirstSessionSig)(pkpSessionSigs);
    const pkpAddress = (0, utils_1.getPkpAddressFromSessionSig)(sessionSig);
    const { publicKey, keyType, dataToEncryptHash, ciphertext, memo } = params;
    return (0, service_client_1.storePrivateKey)({
        storedKeyMetadata: {
            publicKey,
            keyType,
            dataToEncryptHash,
            ciphertext,
            pkpAddress,
            memo,
        },
        sessionSig: (0, utils_1.getFirstSessionSig)(pkpSessionSigs),
        litNetwork: litNodeClient.config.litNetwork,
    });
}
exports.storeEncryptedKey = storeEncryptedKey;
//# sourceMappingURL=store-encrypted-key.js.map